import { render, staticRenderFns } from "./IngredientTable.vue?vue&type=template&id=28d9dc66&scoped=true&"
import script from "./IngredientTable.vue?vue&type=script&lang=js&"
export * from "./IngredientTable.vue?vue&type=script&lang=js&"
import style0 from "./IngredientTable.vue?vue&type=style&index=0&id=28d9dc66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d9dc66",
  null
  
)

export default component.exports